import { defaultTo, isNull } from 'lodash-es';
import { CheckCircle, Timer, XCircle } from 'phosphor-react';
import { DateTime } from '../../lib/date';
import type { AufgabeAbschliessenModel } from './model';
import { toBearbeiterFullName, toBearbeitungsDate } from './utils/helper';

type ErgebnisProtokollProps = {
  aufgabe: AufgabeAbschliessenModel;
};

export const ErgebnisProtokoll = ({ aufgabe }: ErgebnisProtokollProps) => {
  const bearbeiterFullName = toBearbeiterFullName(aufgabe);
  const bearbeitungsDate = toBearbeitungsDate(aufgabe);

  if (isNull(aufgabe.ergebnisOption)) {
    return null;
  }

  const resultIcon = defaultTo({
    Erfolgreich: <CheckCircle />,
    Erfolglos: <XCircle />,
  }[aufgabe.ergebnis ?? ''], <Timer />);

  return (
    <div className="flex flex-col p-2 rounded gap-2 bg-light">
      <p className="flex items-center font-bold gap-2">
        {resultIcon}
        <span className="text-sm">{aufgabe.ergebnisOption ?? 'Abgeschlossen'}</span>
      </p>
      <p className="text-sm whitespace-pre-wrap">{aufgabe.kommentar}</p>
      <small className="text-xs">
        {bearbeiterFullName ? bearbeiterFullName : 'Unbekannter Nutzer'}
        {bearbeitungsDate && <>
          <span className="mx-1">•</span>
          <DateTime date={bearbeitungsDate} />
        </>}
      </small>
    </div>
  );
};
